"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDroppedItemToFormInput = void 0;
const stripHtml = (str) => str.replace(/<[^>]*>/g, "").trim();
// Utility to map dropped item to FormInput
const mapDroppedItemToFormInput = (item, order) => {
    var _a, _b, _c, _d, _e, _f;
    // Check if this item is from a form selection
    if (item.formId) {
        // Item is from a form - preserve the original id as formInputId and create new local id
        return {
            id: `input_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // Generate new local id
            formInputId: item._id || item.id, // Preserve original id as formInputId
            type: item.type || "text",
            name: (item.question || item.label || "")
                .toLowerCase()
                .replace(/\s+/g, "_") || "field_" + Date.now(),
            label: stripHtml(item.question || item.label || "Field"),
            placeholder: item.placeholder || ((_a = item.config) === null || _a === void 0 ? void 0 : _a.placeholder) || "",
            value: item.value || "",
            isRequired: item.isRequired || ((_b = item.config) === null || _b === void 0 ? void 0 : _b.required) || false,
            validations: item.validations || [],
            attributes: item.attributes || {},
            options: item.options || ((_c = item.config) === null || _c === void 0 ? void 0 : _c.options) || [],
            order: (order || 0) + 1,
            formInput: item,
            // Spread any extra properties for flexibility
        };
    }
    else {
        // Item is not from a form - use existing logic
        return {
            // Use _id from question if available, else generate one
            id: item._id ||
                `input_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            type: item.type || "text",
            name: (item.question || item.label || "")
                .toLowerCase()
                .replace(/\s+/g, "_") || "field_" + (item._id || Date.now()),
            label: item.question || item.label || "Field",
            placeholder: item.placeholder || ((_d = item.config) === null || _d === void 0 ? void 0 : _d.placeholder) || "",
            value: item.value || "",
            isRequired: item.isRequired || ((_e = item.config) === null || _e === void 0 ? void 0 : _e.required) || false,
            validations: item.validations || [],
            attributes: item.attributes || {},
            options: item.options || ((_f = item.config) === null || _f === void 0 ? void 0 : _f.options) || [],
            order: (order || 0) + 1,
            // Spread any extra properties for flexibility
        };
    }
};
exports.mapDroppedItemToFormInput = mapDroppedItemToFormInput;
